/* RESPONSIBLE TEAM: team-reporting */

import type { ChartType } from '@/features/report-snapshots/types';

const staticConfig = {
  legend: {
    enabled: true,
    align: 'center',
    margin: 27,
    layout: 'horizontal',
    itemHoverStyle: { color: undefined },
    maxHeight: 70,
  },
  accessibility: {
    enabled: false,
  },
  chart: {
    spacingLeft: 3,
    spacingBottom: 0,
  },
  xAxis: {
    lineColor: 'transparent',
    offset: 7,
    tickLength: 0,
    labels: { style: {} },
  },

  yAxis: {
    gridLineColor: 'var(--neutral-border)',
    offset: 10,
    endOnTick: true,
    maxPadding: 0,
    title: {
      enabled: false,
    },
    labels: { style: {} },
    reversedStacks: false,
  },

  plotOptions: {
    column: {
      maxPointWidth: 32,
      stickyTracking: false,
      states: {
        hover: {
          enabled: false,
        },
      },
      centerInCategory: true,
    },
    bar: {
      maxPointWidth: 32,
      stickyTracking: false,
      states: {
        hover: {
          enabled: false,
        },
      },
    },
    line: {
      stickyTracking: false,
      findNearestPointBy: 'xy',
    },
    area: {
      stickyTracking: false,
      fillOpacity: 0.1,
    },
    columnrange: {
      states: {
        hover: {
          enabled: false,
        },
      },
    },
    series: {
      minPointLength: 4,
      marker: {
        symbol: 'circle',
      },
      states: {
        inactive: {
          opacity: 1,
        },
        hover: {
          enabled: false,
        },
      },
    },
  },

  tooltip: {
    shared: false,
    outside: true,
    enabled: true,
    hideDelay: 50,
    snap: 10,
    borderRadius: 10,
    borderWidth: 1,
    useHTML: true,
    borderColor: 'var(--neutral-border)',
  },

  lang: {
    thousandsSep: ',',
  },
  credits: {
    enabled: false,
  },
} as const;

export default class DefaultSeriesChartConfig {
  declare config: Highcharts.Options;

  constructor(chartType: ChartType) {
    this.config = {
      ...structuredClone(staticConfig),
      chart: { type: chartType },
    } as Highcharts.Options;
  }
}
